import { PropsWithChildren } from 'react';

/**
 * Component that can be used with HeroPage to place content in center column and content row.
 *
 * @param children the content.
 */
export function TopOfContentWrapper({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col items-end gap-4 pb-4 sm:flex-row sm:items-center sm:justify-end">{children}</div>
  );
}
